<label [for]="inputId" *ngIf="inputLabel" class="form-label" [ngClass]="{ disabled: isDisabled }">{{
  inputLabel
}}</label>
<input
  [required]="inputRequired"
  [id]="inputId"
  type="text"
  class="form-control common-form-control"
  [ngClass]="{ disabled: isDisabled }"
  [class.is-invalid]="errorMessage"
  [attr.aria-label]="!inputLabel ? 'Text Input' : null"
  [attr.aria-describedby]="inputDescribedBy"
  [placeholder]="placeholder"
  [(ngModel)]="_inputText"
  (ngModelChange)="handleChange($event)"
  (blur)="handleTouched()"
/>
<div class="mt-1 text-danger" *ngIf="errorMessage">
  <img src="/assets/images/icons/icon-warning.svg" />
  <span class="small fw-light ps-1">{{ errorMessage }}</span>
</div>
<div
  class="mt-2 small text-emphasis-medium fw-light"
  [ngClass]="{ disabled: isDisabled }"
  *ngIf="helperText && !errorMessage"
>
  {{ helperText }}
</div>
